import { PartnerResellers } from '../../../Core/Config/enums/partner-resellers.enum';

export class ResellerConfig {
    reseller: PartnerResellers;
    logoUrl: string;
    logoAltText?: string;
    enableSSO: boolean;
    name?: string;
    points?: {icon: string; text: string}[];
    customSubheading?: string;
    buttonLabel?: string;
    buttonLink?: string;
    copyright?: string;
}

const burellesConfig: ResellerConfig = {
    reseller: PartnerResellers.burrelles,
    logoUrl: 'assets/images/d58b15fb-5604-4394-be91-fa68d2fd8415-logo-5B28B91.svg',
    logoAltText: 'Core.login.burrelles.logoAltText',
    enableSSO: false,
    name: 'The Burrelles Portal',
    points: [
        {icon: 'fa-tv-retro', text: 'Core.login.burelles.point1'},
        {icon: 'fa-circle-play', text: 'Core.login.burelles.point2'},
        {icon: 'fa-chart-column', text: 'Core.login.burelles.point3'},
        {icon: 'fa-circle-check', text: 'Core.login.burelles.point4'}],
    buttonLabel: 'Core.login.reseller.button.learnMore',
    buttonLink:'mailto:inquiry@burrelles.com'
};

const lexisConfig: ResellerConfig = {
    reseller: PartnerResellers.lexisNexis,
    logoUrl: 'assets/images/96b3e718-12e4-4f9c-8379-c0a5520b912b-logo.png',
    logoAltText: 'Core.login.lexis.logoAltText',
    enableSSO: true,
    name: 'Nexis® Media Contacts Solution',
    points: [
        {icon:'fa-user', text: 'Core.login.lexis-unicepta.point1'},
        {icon: 'fa-cloud-arrow-up', text: 'Core.login.lexis-unicepta.point2'},
        {icon: 'fa-paper-plane', text: 'Core.login.lexis-unicepta.point3'},
        {icon: 'fa-chart-column', text: 'Core.login.lexis-unicepta.point4'}]
};

const uniceptaConfig: ResellerConfig = {
    reseller: PartnerResellers.unicepta,
    logoUrl: null,
    enableSSO: true,
    name: 'Unicepta',
    points: [
        {icon:'fa-user', text: 'Core.login.lexis-unicepta.point1'},
        {icon: 'fa-cloud-arrow-up', text: 'Core.login.lexis-unicepta.point2'},
        {icon: 'fa-paper-plane', text: 'Core.login.lexis-unicepta.point3'},
        {icon: 'fa-chart-column', text: 'Core.login.lexis-unicepta.point4'}]
};

const newsdirectConfig: ResellerConfig = {
    reseller: PartnerResellers.newsdirect,
    logoUrl: 'assets/images/6bc67bb0-2ffc-4296-b6c5-738bbae4e214-logo.svg',
    logoAltText: 'Core.login.newsdirect.logoAltText',
    enableSSO: false,
    name: 'DB Direct™ Media Database',
    customSubheading: 'Core.login.newsdirect.customSubheading',
    copyright: 'Core.login.newsdirect.copyright'
};

const paMediaConfig: ResellerConfig = {
    reseller: PartnerResellers.paMedia,
    logoUrl: 'assets/images/0c6572b7-86f6-4fa4-b170-13baa4f551e6-logo.svg',
    logoAltText: 'Core.login.paMedia.logoAltText',
    enableSSO: true,
    buttonLabel: 'Core.login.paMedia.button',
    buttonLink: 'https://explore.pa.media/mediapoint'
};

const kantarConfig: ResellerConfig = {
    reseller: PartnerResellers.kantar,
    logoUrl: 'assets/images/dd4df5cc-7ece-44f5-8ab1-5f8c2b8a9588-login-logo.svg',
    logoAltText: 'Core.login.kantar.logoAltText',
    enableSSO: true,
    customSubheading: 'Core.login.kantar.heading',
    points: [
        {icon: 'fa-envelope', text: 'Core.login.kantar.email'},
        {icon: 'fa-phone', text: 'Core.login.kantar.phone'}
    ]
};

const refmediaConfig: ResellerConfig = {
    reseller: PartnerResellers.refmedia,
    logoUrl: 'assets/images/Refmedia-logo.svg',
    logoAltText: 'Core.login.refmedia.logoAltText',
    enableSSO: false,

};

export const partnerResellerConfigs: Map<PartnerResellers, ResellerConfig> = new Map([
    [PartnerResellers.burrelles, burellesConfig],
    [PartnerResellers.lexisNexis, lexisConfig],
    [PartnerResellers.unicepta, uniceptaConfig],
    [PartnerResellers.newsdirect, newsdirectConfig],
    [PartnerResellers.paMedia, paMediaConfig],
    [PartnerResellers.kantar, kantarConfig],
    [PartnerResellers.refmedia, refmediaConfig]
]);
